import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import DatepickerRange from '../../components/DatepickerRange';
import Input from '../../components/Input';
import Select from '../../components/Select';
import Textarea from '../../components/Textarea';
import Toggle from '../../components/Toggle';

export const selectOptions = [
  { label: 'Einen Tag', value: '1' },
  { label: 'Zwei Tage', value: '2' },
  { label: 'Drei Tage', value: '3' },
  { label: 'Vier Tage', value: '4' },
  { label: 'Fünf Tage', value: '5' },
  { label: 'Sechs Tage', value: '6' },
  { label: 'Sieben Tage', value: '7' },
  { label: 'Acht Tage', value: '8' },
  { label: 'Neun Tage', value: '9' },
  { label: 'Zehn Tage', value: '10' },
  { label: 'Elf Tage', value: '11' },
  { label: 'Zwölf Tage', value: '12' },
  { label: 'Dreizehn Tage', value: '13' },
  { label: 'Vierzehn Tage', value: '14' },
];

type FormProps = {
  isInUpdateState?: boolean;
};

export default function Form({ isInUpdateState = false }: FormProps) {
  const { watch, setValue } = useFormContext();

  const watchNotifyToggle = watch('notifyUserOnWebsite');
  const watchNotifyStartDate = watch('notifyStartDate');

  useEffect(() => {
    if (watchNotifyToggle === false) {
      setValue('notifyStartDate', undefined);
    }
  }, [isInUpdateState, setValue, watchNotifyToggle]);

  useEffect(() => {
    if (watchNotifyToggle === true && !watchNotifyStartDate) {
      setValue(
        'notifyStartDate',
        selectOptions.filter((item) => item.value === '3')[0],
      );
    }
  }, [watchNotifyToggle, watchNotifyStartDate, setValue]);

  return (
    <SpaceBetween size="m">
      <Input name="name" label="Name" stretch />
      <DatepickerRange
        label="Datum"
        placeholder="Datum von / bis"
        description="Tag doppelt auswählen wenn es nur einen Tag betrifft."
        name="range"
      />
      <Toggle
        defaultValue={false}
        label="Das Geschäft ist an dem ausgewählten Zeitraum geschlossen"
        name="is_closed"
      />
      <Textarea
        label="Beschreibung"
        description="Optional"
        name="description"
      />
      <Box>
        <SpaceBetween size="s">
          <Toggle
            defaultValue={false}
            label="Seitenbesucher informieren"
            description="Wird dem Benutzer beim Besuch auf der Website direkt in einem Modal angezeigt. "
            name="notifyUserOnWebsite"
          />
          {watchNotifyToggle && (
            <Select
              label="Wie viele Tage vorher soll der Benutzer informiert werden?"
              name="notifyStartDate"
              options={selectOptions}
            />
          )}
        </SpaceBetween>
      </Box>
    </SpaceBetween>
  );
}
